<template>
 <Head>
    <title> Personal Details | {{$page.props.appName}}</title>
    <meta name="description" :content="'Personal Details ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl p-3 text-black">
      <div class="w-full flex">
        <div class="w-full">
          <h1 class="text-xl">
            Personal Details for {{ $page.props.details.first_name }}
            {{ $page.props.details.middle_name }}
            {{ $page.props.details.surname }}
          </h1>
        </div>
      </div>

      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">First Name:</label>
            <input v-model="$page.props.details.first_name" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Middle Name:</label>
            <input v-model="$page.props.details.middle_name" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Surname:</label>
            <input v-model="$page.props.details.surname" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Site:</label>
            <input v-model="$page.props.details.site" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Department:</label>
            <input v-model="$page.props.details.department" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Phone Number:</label>
            <input v-model="$page.props.details.phone_number" type="text" class="form-input" disabled/>
        </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">National Insurance Number:</label>
            <input v-model="$page.props.details.national_insurance_number" type="text" class="form-input" disabled/>
        </div>
      <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Driving License Number:</label>
            <input v-model="$page.props.details.driving_license_number" type="text" class="form-input" disabled/>
      </div>
       <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Email:</label>
            <input v-model="$page.props.details.email" type="text" class="form-input" disabled/>
      </div>
        <p class="text-red-700 font-semibold">If you need to edit any of these fields, please contact management.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components : {Head}
};
</script>